import React from 'react'

const EnrollHeader = ({ slice }) => {
    return (
        <section className="enroll-header">
            <div className="center-small">
                <div>
                    <p className="enroll-step">{slice.primary.step}</p>
                </div>
                <div>
                    <p>{slice.primary.header1.text}</p>
                </div>
            </div>
        </section>
    )
}

export default EnrollHeader